import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TrayFormViewModelType } from '../../../create-tray-screen/components/view-model-common/view-model-type';
import { PageItemType } from '../../../domain/page-item-type';
import { cloneCxbPageItem, deleteCxbPageItem, updateCxbPageItems } from '../../page-edit-screen.actions';
import { AppState } from '../../page-edit-screen.reducer';
import { PageType } from '../../page-type';
import { TrayTypeBridge } from '../../tray-type-bridge';
import { PageEditTrayItemViewModel } from '../page-edit-screen/page-edit-screen.view-model';

@Injectable()
export class TrayListService {
  constructor(private readonly pageStore: Store<AppState>) {}

  public cloneTray(pageVersionId: string, trayId: string, trayType: TrayFormViewModelType, pageType: PageType, targetPageId: string): void {
    this.pageStore.dispatch(
      cloneCxbPageItem.sourceAction({
        pageVersionId,
        id: trayId,
        pageType,
        trayType: TrayTypeBridge.parseFromFormType(trayType).pageItemType,
        targetPageId,
      })
    );
  }

  public deleteTray(pageVersionId: string, tray: PageEditTrayItemViewModel, pageType: PageType): void {
    let pageItemType: PageItemType = null;
    if (tray.trayType === TrayFormViewModelType.AppsAndGames) {
      pageItemType = TrayTypeBridge.parseFromPageItemType(tray['subType']).pageItemType;
    } else {
      pageItemType = TrayTypeBridge.parseFromFormType(tray.trayType).pageItemType;
    }
    this.pageStore.dispatch(deleteCxbPageItem.sourceAction({ id: tray.id, pageType, pageVersionId, trayType: pageItemType }));
  }

  public updateTraysOrder(pageVersionId: string, trays: PageEditTrayItemViewModel[], pageType: PageType): void {
    const orderedMenuItems: { id: string; order: number }[] = trays.map((tray: PageEditTrayItemViewModel, index: number) => ({
      id: tray.id,
      order: index + 1, // TODO:AB The backend use 1 based ordering, the first
      // item's order is 1 instead of 0 so adding plus one here to match with this logic
    }));
    this.pageStore.dispatch(updateCxbPageItems.sourceAction({ pageVersionId, items: orderedMenuItems, pageType }));
  }

  public updateTraysVisible(pageVersionId: string, trays: PageEditTrayItemViewModel[], pageType: PageType): void {
    const orderedMenuItems: { id: string; visible: boolean }[] = trays.map((tray: PageEditTrayItemViewModel) => ({
      id: tray.id,
      visible: tray.visible,
    }));
    this.pageStore.dispatch(updateCxbPageItems.sourceAction({ pageVersionId, items: orderedMenuItems, pageType }));
  }
}
